import { Box, Stack, Typography } from "@mui/material";
import isologo from "../assets/isologo.png";
import SocialMedia from "./SocialMedia";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          px: 10,
          pt: 10,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img src={isologo} alt="fotonoba isologo" />
      </Box>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          py: 2,
          justifyContent: "center",
        }}
      >
        <SocialMedia />
      </Stack>
      <Typography
        component="p"
        textAlign="center"
        variant="caption"
        sx={{ mb: 2 }}
        gutterBottom
      >
        ¿Querés enviar tus fotos para publicar?{" "}
        <Link to="/how-to" style={{ color: "inherit" }}>
          ¡Aca toda la info!
        </Link>
      </Typography>
      <Typography
        component="p"
        textAlign="center"
        variant="caption"
        sx={{ mb: 2 }}
      >
        ¿Sugerencias para el sitio?{" "}
        <a
          href="mailto:fotonobatecnologia@gmail.com"
          style={{ color: "inherit" }}
        >
          ¡Escribinos acá para incorporarlas!
        </a>
      </Typography>
    </>
  );
};
export default Footer;
